export const QUERY_KEY_ERRORS_TYPES = 'error_types';
export const QUERY_KEY_ERRORS_TODAY = 'error_today';
export const QUERY_KEY_ERRORS_ALL_TIME = 'error_all_time';
export const QUERY_KEY_ERRORS_DATE = 'error_date';
export const QUERY_KEY_ERRORS = 'errors';
export const QUERY_KEY_ERROR = 'error';
